<script>
	import Starfield from './Starfield.svelte'; 

	import { onMount } from 'svelte';
	import {getChar} from './getChar';

	import { starData, indSlide, indSel, margCorrect, formEntries, scrollTrigger } from './stores.js';

	import * as animateScroll from "svelte-scrollto";

	export let cols, drawOutlines;

	let responses = {
		"loading":{
			Authorid: "loading", 
			Author: "", 
			Reason:`*•*`,
			Location:``,
			Published: "1"
		}
	};

	let allStars = [];

	let prompts = {
		list:[
			{
				msg:`I am getting vaccinated because...`,
				ys:0, can_id:"main"
			},{
				msg:`↓`,
				ys:1, can_id:"main"
			},{
				msg:`↓ click •••••• to explore stories`,
				ys:2, can_id:"because"
			},{
				msg:`↓ click • to add your story`,
				ys:3, can_id:"because"
			},{
				msg:`I am getting vaccinated because...`,
				ys:0, can_id:"alsobecause"
			}
		]
	};

	let nResponses = 25;
	let look_ahead = parseInt(0.5*(nResponses)+0.5);

	let main_holder;

	let canvas = {
		main:null,
		char:null,
		because:null
	};

	let context = {
		main:null,
		char:null,
		because:null
	};

	let layers = [];

	let ind_Now = -1;

	let timers = {
		scroll:-1,
		test:{start:-1,fetch:-1},
		sel:-1,
		resize:-1,

	}

	let scroll = {
		duration:1000,
		trigger:false,
		submitted:false,
		focussed:false
	}

	// let letterlist = [
	// 	'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
	// 	'S','T','U','V','W','X','Y','Z','0','1','2','3','4','5','6','7','8','9',
	// 	'.','!','?',',',';',':','_','(',')','\'','/','\\','-','=','+','÷','*',
	// 	'%','$','#','@','<','>','^','"','&'
	// ];

	let star = {
		rows:[],
		char:{},
		selected:{},
		cursor: {x:0,y:0},
		box: {w:0,h:0},
		c: {x:0,y:0},
		corners:[],
		trow:0,
		y0:0
	};

	// for dev testing
	let totalResponses = 420;

	let lw = 0.2; //
	let fct = 1;
	let rat = 1.2941;

	let frame = -1;

	let count = {
		fwd:{
			now:0,
			max:2,
		},
		rev:{
			now:0,
			max:2
		},
		hold: {
			now:0,
			max:100
		},
		mode:'strt',
		paused:false,
		delay:{
			max:25,
			cnt:0
		}
	}

	let scl = {};
	let sp = {};

	let margin = {};

	let box = {};

	export let dim = {
		w:300, h:300, 
		prev:{w:-1,h:-1},
		ratio:1, scl:-1
	};

	const setCharCan = (can,ctx,col,sz) => {
		ctx.clearRect(0,0,can.width,can.height);
		ctx.lineWidth = sz*dim['ratio']*lw*scl.x;

		ctx.globalAlpha = 0.8; // tape opacity
		ctx.strokeStyle = cols[col]['hex'];
	}

	const drawCharToLayer = (layer,ch) => {
		context['main'].drawImage(
			canvas['char'],
			dim['ratio']*(ch['cursor'].x - layer['sz']*sp.mx - layer['sz']*scl.x*ch['kern'] + layer['c'].x),
			dim['ratio']*(ch['cursor'].y - layer['sz']*sp.my +  + layer['c'].y),
			canvas['char'].width,canvas['char'].height
		);

	}

	const drawSeg = (ctx,tape,sz,c) => {

		if (typeof c == 'undefined') {
			c = {x:0,y:0}
		}

		ctx.beginPath();
		ctx.moveTo(
			dim['ratio']*sz*(scl.x*tape[0][0] + sp.mx + c.x), 
			dim['ratio']*sz*(scl.y*tape[0][1] + sp.my + c.y)
		);
		ctx.lineTo(
			dim['ratio']*sz*(scl.x*tape[1][0] + sp.mx + c.x), 
			dim['ratio']*sz*(scl.y*tape[1][1] + sp.my + c.y) 
		);

		ctx.stroke();
	}

	const greenOutlines = (ctx,sz) => {

		if (!drawOutlines) return;

		let ww = sz*(scl.x + 2*sp.mx);
		let hh = sz*(scl.y + 2*sp.my);

		// char canvas outline (green with X)\
		ctx.strokeStyle = '#0a0';
		ctx.lineWidth = 3;
		ctx.beginPath();
		ctx.rect(
			0,0,
			dim['ratio']*ww, 
			dim['ratio']*hh
		);
		ctx.stroke();

		ctx.lineWidth = 1;
		ctx.beginPath();
		ctx.moveTo(0,0);
		ctx.lineTo(dim['ratio']*ww,dim['ratio']*hh);
		ctx.moveTo(dim['ratio']*ww,0);
		ctx.lineTo(0,dim['ratio']*hh);
		ctx.stroke();
	}

	const drawChar = (layer,char,col) => {

		setCharCan(canvas['char'],context['char'],col,layer['sz']*char.sz);

		let seg = layer['char']['seg'];

		let c = {
			x: 2*(1-char.sz)*scl.x,
			y: 2*(1-char.sz)*scl.y
		}

		drawSeg(context['char'],char.coords[seg],layer['sz']*char.sz,c);
		layer['totalSegsDrawn'] ++

		if (seg == 0) {
			greenOutlines(context['char'],layer['sz']);
		}
	}

	const lineBreak = (cursor,sz,indent) => {

		cursor.x = sz*indent,//0.5*margin.x;
		cursor.y += sz*scl.y; // add letter height
		cursor.y += sz*sp.y;  // add line height
		//console.log('lineBreak [' + cursor.x + ' ' + cursor.y + ']' )
	}

	const getWords = (layer,word,sz,rel_sz) => {

		let characters = [];
		let pos = layer['cursor'].x;

		//console.log(word)
		//  get word length and tape segments
		word.split('').forEach(ch => {
			// if (ch == '\n') {

			// 	characters.push({
			// 		kern:0,
			// 		coords:[],
			// 		char:'\n',
			// 		cursor:{}
			// 	});
			// 	return;
			// }

			let character = getChar(ch,lw,rat); // returns {coords:[]}

			character.kern = character.kern || 0;
			character.char = ch;
			character.cursor = {};
			character.sz = rel_sz;

			character.kern *= rel_sz;

			pos += rel_sz*sz*scl.x*(1 - 2*character.kern);
			pos += rel_sz*sz*sp.x;

			// console.log(ch)
			// console.log(pos)

			characters.push(character);
		});

		//  console.log(`${pos} > (${dim['w']} - ${2*margin.x})`)
		// check for linebreak
		if (pos > (dim['w'] - 0.5*margin.x)) {
			lineBreak(layer['cursor'],rel_sz*sz,layer['char']['indent']);
			//characters.push({kern:0,coords:[],char:'\n'});
		}

		characters.forEach((ch,i) => {

			// if (ch.char == '\n') {
			// 	lineBreak(layer['cursor'],sz,layer['char']['indent']);

			// 	ch.cursor = {
			// 		x:layer['cursor'].x,
			// 		y:layer['cursor'].y
			// 	}

			// 	return;
			// }

			ch.cursor = {
				x:layer['cursor'].x,
				y:layer['cursor'].y
			}

			layer['cursor'].x += rel_sz*sz*scl.x*(1-2*ch.kern);
			layer['cursor'].x += rel_sz*sz*sp.x;
			
			if (layer['cursor'].x > layer['box'].w) {
				layer['box'].w = layer['cursor'].x;
			}


		});

		layer['box'].h = layer['cursor'].y + sz*scl.y;

		// add space between words
		layer['cursor'].x += rel_sz*sz*sp.sp;   //1.15*scl.x;
		
		return characters;
	}

	const getLayerFrame = () => {
		layers[0]['frame'] = {
			w: dim['w']-layers[0]['marg'].x,
			h: dim['h']-layers[0]['marg'].y,
			x: 0.5*layers[0]['marg'].x,
			y: 0.5*layers[0]['marg'].y
		};
	}

	const setPrompts = () => {

		getLayerFrame();

		let y_prev = 0;
		let y_tot = 0;
		let ydiff = dim['h'] - dim['screen_h'];

		prompts['list'].forEach((sect,i) => {

			// if (scroll['submitted'] && i == 2) return;

			let words = sect['msg'].toUpperCase().split(' ');

			sect['cursor'] = {
				x:0,y:0
			};

			if (sect['ys'] == 0) {sect['y0'] = 0; }
			if (sect['ys'] == 1) {sect['y0'] = dim['screen_h'] - prompts['sz']*(scl.y + 2*sp.my);}

 			if (sect['ys'] == 2) {sect['y0'] = 0.5*margin.sect;}
			if (sect['ys'] == 3) {sect['y0'] = margin.sect + prompts['sz']*(y_prev );}

			// if (sect['ys'] == 2) {sect['y0'] = prompts['sz']*(scl.y + 2*sp.my);}
			// if (sect['ys'] == 3) {sect['y0'] = y_prev+ydiff;}

			sect['box'] = {
				w:0,h:0,
				x:0,y:0
			};

			sect['characters'] = [];
			sect['char']['ind'] = 0;
			sect['char']['seg'] = 0;
			if (i == 2 || i == 3) {
				sect['char']['indent'] = sp.sp;
			}
			
			
			words.forEach(word => {
				sect['characters'].push(...getWords(sect,word,prompts['sz'],1));
			});

			// fix layer box to text
			//sect['box'].w -= 0.5*margin.x;
			//sect['box'].w -= prompts['sz']*sp.x;
			//sect['box'].h -= 0.5*sect['marg'].y;

			if (i == 0) {
				layers[0]['frame'].y = sect['box'].h;
			}

			sect['can'].width = dim['ratio']*(sect['box'].w + margin.sect);
			sect['can'].height = dim['ratio']*(sect['box'].h + margin.sect);
			sect['can'].style.width = (sect['box'].w + margin.sect) + 'px';
			sect['can'].style.height = (sect['box'].h + margin.sect) + 'px';

			if (i == 2) {
				y_prev = sect['y0'] + sect['box'].h  + 4*sp.my;
				y_tot = sect['box'].h + margin.sect;
			}
			if (i == 3) {
				y_tot += sect['box'].h + margin.sect;
			}

			if (i == 0)  {
				canvas['alsobecause'].width = dim['wr'];
				canvas['alsobecause'].style.width = dim['w'] + 'px';

				canvas['alsobecause'].height = dim['ratio']*(sect['box'].h + margin.sect);
				canvas['alsobecause'].style.height = (sect['box'].h + margin.sect) + 'px';
			}
		});
		
		canvas['because'].width = dim['wr'];
		canvas['because'].style.width = dim['w'] + 'px';

		canvas['because'].height = dim['ratio']*Math.floor(y_tot);
		canvas['because'].style.height = Math.floor(y_tot) + 'px';
		
		prompts['list'].forEach((sect,i) => {
			//if (i > 3) return;

			sect['characters'].forEach((ch,j) => {

				sect['char']['ind'] = j;

				// custom colouring
				let col = cols.length-1;
				if (i == 2) {
					if (j >= 6 && j<=(5+cols.length-1)) {
						col = j-6;

					}
				}

				setCharCan(prompts['can'],prompts['ctx'],col,prompts['sz']);

				ch['coords'].forEach(seg=>{
					drawSeg(prompts['ctx'],seg,prompts['sz']);
				});

				greenOutlines(prompts['ctx'],prompts['sz']);

				let wc = sect['box'].w + 2*sp.x;
				sect['ctx'].drawImage(
					prompts['can'],
					dim['ratio']*(ch['cursor'].x - prompts['sz']*sp.mx - prompts['sz']*scl.x*ch['kern'] + 0.5*margin.sect),
					dim['ratio']*(ch['cursor'].y - prompts['sz']*sp.my + 0.5*margin.sect) ,
					prompts['can'].width,
					prompts['can'].height
				);
			});
		});

		drawPrompts();

	}

	const buildSentence = (layer,words) => {

		resetCursor(layer);

		// build character array from words

		layer['char']['indent'] = 0;

		words['response'].forEach(word => {
			layer['characters'].push(...getWords(layer,word,layer['sz'],1));
		});

		lineBreak(layer['cursor'],layer['sz'],0);
		layer['cursor'].y += 0.5*layer['sz']*scl.y; 

		let rel_sz = 0.5;
		let y_name = layer['cursor'].y;
		if (words['name'][0] == '-') {
			layer['char']['indent'] = sp.sp/rel_sz;
		}

		let names = [];
		words['name'].forEach(word => {
			names.push(...getWords(layer,word,layer['sz'],rel_sz));
		});

		// no line break so slide name over
		if (parseInt(layer['cursor'].y) == parseInt(y_name)) {
			let name_offset = layer['box'].w - layer['cursor'].x;
			names.map(name =>{
				name.cursor.x += name_offset;
				return name;
			})
		}
		
		layer['characters'].push(...names);

		// build segment array from charcters
		layer['segs'] = [];
		layer['totalSegsDrawn'] = 0;
		layer['characters'].forEach((ch,i) => {
			 for (let c=0; c<ch.coords.length; c++) {
				layer['segs'].push({ ind:i, coord:c, sz:ch.sz });
			 }
		});

		// fix layer box to text
		layer['box'].w -= 0.5*layer['marg'].x;
		layer['box'].w -= layer['sz']*sp.x;
		layer['box'].h -= 0.5*layer['marg'].y;

	}
	
	const getSentence = (layer) => {


		if (layer['hasSentence']) return;
		if (typeof responses[layer['id']] == 'undefined') return;
		
		let words = {};
		//console.log('getSentence')
		//layer['col'] = parseInt(allStars[ind_Now].Colour);
		//console.log(responses[layer['id']])
		layer['col'] = responses[layer['id']].Colour;

		let name_arr = responses[layer['id']].Author.toUpperCase().split(' ');

		let arr = {name:[],loc:[]};

		if (responses[layer['id']].Location.length > 0) {
			arr['loc'] = responses[layer['id']].Location.toUpperCase().split(' ');
		}
		if (responses[layer['id']].Author.length > 0) {
			arr['name'] = ['-',...responses[layer['id']].Author.toUpperCase().split(' ')]

			if (arr['loc'].length > 0) {
				arr['name'][arr['name'].length-1] = arr['name'][arr['name'].length-1] + ',';
			}
		}

		if (arr['name'].length == 0 && arr['loc'].length > 0) {
			arr['name'] = ["FROM"];
		}
		
		words = {
			response:responses[layer['id']].Reason.toUpperCase().split(' '),
			name:[...arr['name'],...arr['loc']]
		};

		layer['hasSentence'] = true;

		clearMain();
		
		layer['sz'] = layer['sz0'];
		
		buildSentence(layer,words);

		// iterate down until text fits inside available space.
		let avail = dim['h'] - layers[0]['marg'].y;
		let actual = layer['box'].h;

		if (actual > avail) {
			layer['sz'] -= (1-avail/actual);
			buildSentence(layer,words);
		}

		layer['c'] = {
			x: 0.5*(dim.w-layer['box'].w-layer['marg'].x),
			y: 0.5*(dim.h-layer['box'].h-layer['marg'].y)  
		};

		// if (scroll['submitted']) { // no action prompt so move message down
		// 	layer['c'].y += 0.5*layers[0]['marg'].y;
		// }

		if (layer['c'].x < 0) {layer['c'].x = 0;}
		if (layer['c'].y < 0) {layer['c'].y = 0;}

		//makeOutlines(context['main'],layers[0]['marg'],layers[0]['box'],layers[0]['frame'],layers[0]['c']);
	}

	const drawCharacter = (layer,col)  => {

		let ch = layer['characters'][layer['char']['ind']];

		drawChar(layer,ch,col);

		drawCharToLayer(layer,ch);

		if (drawOutlines) {
			// testing: outline letters (red)
			context['main'].globalAlpha = 1;
			context['main'].strokeStyle = '#f00';
			context['main'].lineWidth = 1;
			context['main'].beginPath();
			context['main'].rect(
				dim['ratio']*(ch['cursor'].x + layer['c'].x), 
				dim['ratio']*(ch['cursor'].y + layer['c'].y), 
				dim['ratio']*layer['sz']*scl.x*(1-2*ch.kern), 
				dim['ratio']*layer['sz']*scl.y
			);
			context['main'].stroke();
		}
	}
	
	function loop(t) {

		frame = requestAnimationFrame(loop);

		if (count['paused']) return;

		getSentence(layers[0]);

		// this prevents loading segments from apearing until after count.delay.max
		if (count['delay']['cnt'] != -1){
			count['delay']['cnt'] ++;
			if (count['delay']['cnt'] > count['delay']['max']) {
				count['delay']['cnt'] = -1;
			}
			return;
		}
		

		if (count['mode'] == 'fwd') {

			if (layers[0]['characters'].length == 0) return;

			count['fwd']['now'] ++;
			if (count['fwd']['now'] > count['fwd']['max']) {
				count['fwd']['now'] = 0;
				moveCursor();
			}

			if (layers[0]['char']['ind'] >= layers[0]['characters'].length) {
				count['mode'] = "hold";
				count['hold']['now'] = 0;
			}
		}

		if (count['mode'] == 'hold') {
			count['hold']['now'] ++;
			if (count['hold']['now'] > count['hold']['max']) {
				count['hold']['now'] = 0;
				count['mode'] = "rev";
			}
		}

		if (count['mode'] == 'rev') {
			count['rev']['now'] ++;
			if (count['rev']['now'] > count['rev']['max']) {
				count['rev']['now'] = 0;
				disintegrate();
			}
		}
		
	}

	const scaleChar = () => {

		scl.x = dim['scl'];
		scl.y = scl.x*rat;

		sp = {
			x:0.15*scl.x,		// letter spacing
			y:0.15*scl.y, 		// line spacing
			mx:0.15*scl.x,		// char canvas margins (x)
			my:0.15*scl.y, 		// char canvas margins (y)
			sp:scl.x 			// space bar
		};

		margin = {
			x:Math.floor(0.1*dim['w']),
			sect:sp.sp // section canvas margins
		};

		if (margin.x < 50) {margin.x = 50;}

		margCorrect.set({
			margx: margin.x,
			scl: 2*scl.x,
			w: dim['w']
		});

		let wc = scl.x + 2*sp.mx;
		let hc = scl.y + 2*sp.my;

		canvas['char'].width = dim['ratio']*wc;
		canvas['char'].height = dim['ratio']*hc;
		canvas['char'].style.width = `${wc}px`;
		canvas['char'].style.height = `${hc}px`;

		prompts['can'].width = dim['ratio']*wc*prompts['sz'];
		prompts['can'].height = dim['ratio']*hc*prompts['sz'];
		prompts['can'].style.width = `${wc*prompts['sz']}px`;
		prompts['can'].style.height = `${hc*prompts['sz']}px`;

		let nrows = (allStars.length-1)/(dim['h']-margin.x);

		scroll['duration'] = nrows*scl.x/3;
		if (scroll['duration'] < 1000) {scroll['duration'] = 1000;}
	}

	const resetCursor = (layer) => {

		layer['cursor'] = {
			x:layer['frame']?.x || 0,
			y:layer['frame']?.y || 0
		};
		layer['box'] = {
			w:0,h:0,
			x:0,y:0
		};

		layer['characters'] = [];
		layer['char']['ind'] = 0;
		layer['char']['seg'] = 0;
	}

	const resetMode = () => {
		count['fwd']['now'] = 0;
		count['rev']['now'] = 0;
		count['hold']['now'] = 0;

		count['mode'] = "fwd";
	}

	const nextResponse = () => {
		//console.log('nextResponse')
		if (layers[0]['clicked']) {
			
			layers[0]['clicked'] = false;

			layers[0]['characters'] = [];
			layers[0]['id'] = allStars[ind_Now]['Authorid'];

			// getSentence won't trigger until this is false
			layers[0]['hasSentence'] = false;

			// (already got the response)
		}
		else {

			// console.log(`ind_Now: ${ind_Now}`)
			// console.log(responses)

			if (ind_Now == -1) { // loading
				layers[0]['char']['ind'] = 0;
				layers[0]['char']['seg'] = 0;

				responses[layers[0]['id']].Colour ++;
				if (responses[layers[0]['id']].Colour > (cols.length-2)) responses[layers[0]['id']].Colour = 0;

				layers[0]['col'] = responses[layers[0]['id']].Colour;
				
				resetMode();
				return;
			}

			ind_Now ++;
			if (ind_Now > allStars.length-1) {
				ind_Now = 0;
			}

			indSlide.set(ind_Now);
			
			layers[0]['characters'] = [];
			layers[0]['id'] = allStars[ind_Now]['Authorid'];
			layers[0]['hasSentence'] = false;
		
			let chk_ind = ind_Now + look_ahead;
			if (chk_ind > allStars.length-1) {chk_ind = 0;}

			let chk_id = allStars[chk_ind]['Authorid'];
			if (typeof responses[chk_id] == 'undefined') {
				getResponses(chk_id);
			}
		}

		resetMode();
	}

	const drawPrompts = () => {

		prompts['list'].forEach((sect,i) => {
			let can = sect['can_id'];

			context[can].drawImage(
				sect['can'],
				0,0,
				sect['can'].width,
				sect['can'].height,
				dim['ratio']*0.5*(margin.x-margin.sect),
				dim['ratio']*(sect['y0']-0.5*margin.sect),
				sect['can'].width,
				sect['can'].height
			);

			if (drawOutlines) {

				context[can].strokeStyle = '#f0f';
				context[can].lineWidth = 5;
				context[can].beginPath();
				context[can].rect(
					dim['ratio']*0.5*(margin.x-margin.sect),
					dim['ratio']*(sect['y0']-0.5*margin.sect),
					sect['can'].width,
					sect['can'].height
				);
				context[can].stroke();

			}
		});

		if (drawOutlines) {
			context['main'].strokeStyle = '#ff0';
			context['main'].lineWidth = 5;
			context['main'].beginPath();
			context['main'].rect(
				0,0,//0.5*margin.sect,0.5*margin.sect,
				dim['wr'],
				canvas['main'].height
			);
			context['main'].stroke();

			context['because'].strokeStyle = '#ff0';
			context['because'].lineWidth = 5;
			context['because'].beginPath();
			context['because'].rect(
				0,0,//0.5*margin.sect,0.5*margin.sect,
				canvas['because'].width,
				canvas['because'].height
			);
			context['because'].stroke();

			context['alsobecause'].strokeStyle = '#ff0';
			context['alsobecause'].lineWidth = 5;
			context['alsobecause'].beginPath();
			context['alsobecause'].rect(
				0,0,//0.5*margin.sect,0.5*margin.sect,
				canvas['alsobecause'].width,
				canvas['alsobecause'].height
			);
			context['alsobecause'].stroke();
		}
	}

	const clearMain = () => {

		context['main'].clearRect(0,0,canvas['main'].width,canvas['main'].height);
		context['main'].globalAlpha = 1;
		context['because'].clearRect(0,0,canvas['because'].width,canvas['because'].height);
		context['because'].globalAlpha = 1;
		context['alsobecause'].clearRect(0,0,canvas['alsobecause'].width,canvas['alsobecause'].height);
		context['alsobecause'].globalAlpha = 1;
		

		drawPrompts();

	}

	const disintegrate = () => {

		clearMain();

		setCharCan(canvas['char'],context['char'],layers[0]['col'],layers[0]['sz']);

		let ind_prev = 0;

		// randomly remove segments across sentence
		let nseg_remove;

		if (layers[0]['clicked']) {
			nseg_remove = 1 + parseInt((layers[0]['totalSegsDrawn'])/20 + 0.5);
		}
		else {
			nseg_remove = 1 + parseInt(Math.random()*5 +0.5);
		}

		if (nseg_remove >= (layers[0]['segs'].length - 1)) {
			layers[0]['segs'] = [];
		}
		else {
			for (let i=0; i<nseg_remove; i++) {
				if (layers[0]['segs'].length == 0) continue;

				// choose a random segment and remove it from the whole sentence
				let ind = parseInt(Math.random()*(layers[0]['segs'].length-1) + 0.5);
				layers[0]['segs'].splice(ind,1);
			}
		}

		//console.log('nseg_remove: ' + nseg_remove + ', segs.length: ' + layers[0]['segs'].length)

		// if no more segments, move to next sentence
		if (layers[0]['segs'].length == 0) {
			//console.log(`next response ...`);
			nextResponse();

			return;
		}

		// draw all characters by remaining segments
		layers[0]['segs'].forEach((seg,i) => {
			
			// new character, draw previous character to layer and reset char canvas
			if (seg.ind != ind_prev) {
				drawCharToLayer(layers[0],layers[0]['characters'][ind_prev]);
				setCharCan(canvas['char'],context['char'],layers[0]['col'],layers[0]['sz']*seg.sz);
			}

			let tape = layers[0]['characters'][seg.ind]['coords'][seg.coord];

			let c = {
				x: 2*(1-seg.sz)*scl.x,
				y: 2*(1-seg.sz)*scl.y
			}

			drawSeg(context['char'],tape,layers[0]['sz']*seg.sz,c);

			ind_prev = seg.ind;

		});

		// last seg
		drawCharToLayer(layers[0],layers[0]['characters'][ind_prev]);

	}

	const moveCursor = () => {

		if (layers[0]['characters'].length == 0) return;

		// draws one new character
		drawCharacter(
			layers[0],
			layers[0]['col']
		);

		layers[0]['char']['seg'] ++;

		if (layers[0]['char']['seg'] >= layers[0]['characters'][layers[0]['char']['ind']]['coords'].length) {
			layers[0]['char']['seg'] = 0;
			layers[0]['char']['ind'] ++;
		}

	}

	// const handleKeydown = (e) => {
	// 	console.log(e.keyCode);
	// 	if (e.keyCode == 108) {
	// 		drawOutlines = !drawOutlines;
	// 		//drawStarSprites();
	// 		//loop();
	// 	}
	// 	if (e.keyCode == 46) { // >
	// 		nextResponse();
	// 	}

	// 	if (e.keyCode == 120) { // x

	// 		count['paused'] = !count['paused'];
	// 	}

	// 	if (e.keyCode == 13 && scroll['focussed']) {

	// 		if (!scroll['submitted']) {
	// 			animateScroll.scrollTo({element: '#end',duration:scroll['duration']});
	// 		}
	// 	}
	// }

	const setSize = (noPrompts) => {

		dim['w'] = main_holder.offsetWidth;
		dim['h'] = main_holder.offsetHeight;

		dim['screen_h'] = window.innerHeight - 20; // this 20 must match the padding in class .pdtop

		// if (dim['h'] < 0.5*dim['screen_h']) { // element not loaded yet
		// 	dim['prev']['h'] = -1;
		// }

		// console.log('setSize()')
		// console.log(dim['w'] + ' ' + dim['h'] + ' ' + dim['screen_h'])

		// dim['w'] = Math.max(window.innerWidth, document.body.offsetWidth);
		// dim['h'] = Math.max(window.innerHeight, document.body.offsetHeight);

		let diff = {
			w:dim['w']-dim['prev'].w,
			h:dim['h']-dim['prev'].h
		}

		//console.log(diff);

		// no need to resize something that's the same
		if ((diff.w+diff.h) == 0) { return; }

		// set new dim to previous dim
		if (!noPrompts) {
			dim['prev'] = {w:dim['w'],h:dim['h']};
		}

		const devicePixelRatio = window.devicePixelRatio || 1;
		const backingStoreRatio = canvas['main'].webkitBackingStorePixelRatio ||
			canvas['main'].mozBackingStorePixelRatio ||
			canvas['main'].msBackingStorePixelRatio ||
			canvas['main'].oBackingStorePixelRatio ||
			canvas['main'].backingStorePixelRatio || 1;

		dim['ratio'] = devicePixelRatio / backingStoreRatio;

		dim['scl'] = Math.max(Math.ceil(0.03*dim['w']),25);

		dim['wr'] = dim['w']*dim['ratio'];
		dim['hr'] = dim['h']*dim['ratio'];
		
		canvas['main'].width = dim['wr'];
		canvas['main'].height = dim['hr'];
		canvas['main'].style.width = dim['w'] + 'px';
		canvas['main'].style.height = dim['h'] + 'px';  

		// console.log(' ')
		// console.log('setSize()');
		// console.log(`[${dim['w']} x ${dim['h']}] -> [${dim['wr']} x ${dim['hr']}]`);
		
		scaleChar();

		// box = {
		// 	w: dim['w']-margin.x,
		// 	h: dim['h']-margin.y,
		// 	x: 0.5*margin.x,
		// 	y: 0.5*margin.y
		// };
		//console.log('noPrompts: ' + noPrompts)
		if (!noPrompts) {setPrompts()};

		
		clickInit(ind_Now);
		
		
	}

	const doResize = () => {
	
		clearTimeout(timers['resize']);
		
		timers['resize'] = setTimeout(() => {
			setSize();
		}, 200);
	}

	const startJob = () => {
		console.log('startJob() .');
		console.log(`isProd:  ${__myapp.env.isProd}`);

		setSize(true);

		if (__myapp.env.isProd) {

			let formData = new FormData();

			formData.append('all',1);

			fetch('../viewer.php', {
				method: 'post',
				body: formData
			}).then(response => {
				//if (!response.ok) { throw response }
				return response.json();
			}).then(json => {
				//console.log(json)
				if (json['status'] == 'success') {

					allStars.push(...json['rows']);

					//ind_Now = 0;

					// sent to stores.js
					starData.set(allStars);
					//indSlide.set(ind_Now);

					//clickInit(ind_Now);

					setSize();

					getResponses(allStars[0]['Authorid']);
				}
				else {
					//console.log('no quotes')
					//writeError(json['msg']);
				}
			}).catch( err => {
				console.log(err)
				//writeError(err);
			});
		}
		else {

			console.log('fetching allStars ...');
			setSize();

			for (let i=0; i<totalResponses; i++) {
				allStars.push({
					Colour:`${parseInt(Math.random()*(cols.length-2 + 0.5))}`,
					Authorid:`${totalResponses-1-i}`
				});

				// for testing
				if (i == 0) {
					allStars[i]['Colour'] = `${cols.length-1}`;
				}
				if (i == 2) {
					allStars[i]['Colour'] = `${cols.length-1}`;
				}
				if (i == totalResponses-1) {
					allStars[i]['Colour'] = `${cols.length-1}`;
				}
			}

			// imiate delay in fetching from server
			clearTimeout(timers['test']['start']);
			timers['test']['start'] = setTimeout(() => {

				console.log('fetched');

				//ind_Now = 0;

				// sent to stores.js
				// starData.set(allStars);
				// indSlide.set(ind_Now);

				starData.set(allStars);

				// layers[0]['id'] = allStars[ind_Now]['Authorid'];

				console.log(allStars);

				setSize();

				getResponses(allStars[0]['Authorid']);

				//clickInit(ind_Now);

				//setSize();
				
			},500);
		}
	}

	const getResponses = (authorid) => {
		console.log('getResponses('+authorid+')')

		if (__myapp.env.isProd) {
			
			// prod -- pull from SQL
			let formData = new FormData();

			formData.append('numQuote',nResponses);
			formData.append('id',authorid);
			formData.append('all',0);

			fetch('../viewer.php', {
				method: 'post',
				body: formData
			}).then(response => {
				//if (!response.ok) { throw response }
				return response.json();
			}).then(json => {
				//console.log(json)
				if (json['status'] == 'success') {

					if (ind_Now == -1) {
						count['delay']['cnt'] = -1;
					 	ind_Now = 0;
					 	indSlide.set(ind_Now);
					 	clickInit(ind_Now);
					 }

					json['rows'].forEach(row => {
						responses[row.Authorid] = row;
					});
					
					// console.log('received batch from getResponses()');
					//console.log(json['rows'])
					// console.log(responses)
					// console.log('--');
				}
				else {
				//	console.log('no quotes')
					//writeError(json['msg']);
				}
			}).catch( err => {
				//console.log(err)
				//writeError(err);
			});

		}
		else {

			console.log('fetching response ...');
			let ind = ind_Now;
			let json = {
				rows:[]
			}

			if (ind == -1) {ind = 0;}

			console.log('ind: ' + ind)
			for (let i=0; i<nResponses; i++) {
				let id = allStars[ind]['Authorid'];
				//console.log(ind + ' ' + id)
				let row = {
					Authorid: id, 
					Author: "anonymous", 
					Reason:`é ind: ${ind}, id -> ${id} é`,
					Location:`earth`,
					Published: "1", 
					Colour: allStars[ind]['Colour']
				};
				json['rows'].push(row);
				ind ++;
				if (ind > nResponses-1) break;
			}

			// imiate delay in fetching from server
			clearTimeout(timers['test']['fetch']);
			timers['test']['fetch'] = setTimeout(() => {

				console.log('fetched!');

				if (ind_Now == -1) {
					count['delay']['cnt'] = -1;
				 	ind_Now = 0;
				 	indSlide.set(ind_Now);
				 	clickInit(ind_Now);
				 }

				json['rows'].forEach(row => {
					responses[row.Authorid] = row;
				});

				console.log(responses)
				
			},500);
		}
		
	}

	onMount(() => {

		context['main'] = canvas['main'].getContext('2d');
		context['because'] = canvas['because'].getContext('2d');
		context['alsobecause'] = canvas['alsobecause'].getContext('2d');

		canvas['char'] = document.createElement('canvas');
		context['char'] = canvas['char'].getContext('2d');

		let ll = 0;

		layers[ll] = {
			box:{x:0, y:0},
			sz:1,
			sz0:1,
			characters:[],
			cursor:{x:0, y:0},
			segs:[],
			col:-1,
			char:{seg:0, ind:0, indent:0},
			marg:{x:0, y:0},
			hasSentence:false,
			clicked:false,
			id:"loading"
		};

		// layers[ll]['char']['can'] = document.createElement('canvas');
		// layers[ll]['char']['ctx'] = layers[ll]['char']['can'].getContext('2d');

		
		prompts['list'].forEach(sect => {
			sect['characters'] = [];
			sect['cursor'] = {x:0, y:0};
			sect['char'] = {seg:0, ind:0, indent:0};
			sect['can'] = document.createElement('canvas');
			sect['ctx'] = sect['can'].getContext('2d');
		});

		prompts['box'] = {x:0, y:0};
		prompts['sz'] = 0.7;

		prompts['can'] = document.createElement('canvas');
		prompts['ctx'] = prompts['can'].getContext('2d');


		responses['loading']['Colour'] = `${parseInt(Math.random()*(cols.length-2) + 0.5)}`;

		startJob();

		frame = requestAnimationFrame(loop);

		return () => {
			cancelAnimationFrame(frame);
		};
	});

	const clickInit = (ind) => {

		//console.log('clickInit('+ind+')')

		if (ind == -1) {
			count['hold']['now'] = 0;
			count['mode'] = "fwd";

			layers[0]['hasSentence'] = false;

			return;
		}

		layers[0]['clicked'] = true;
			
		ind_Now = ind;

		indSlide.set(ind_Now);

		let id_ = allStars[ind]['Authorid'];

		// check if we need to fetch
		if (typeof responses[id_] == 'undefined') {
			//console.log('getting response')
			getResponses(id_);
		}

		// triggers disintegrate() !!
		// total segs is as many as we happen to have at the time of clicking.
		layers[0]['segs'].splice(layers[0]['totalSegsDrawn'],layers[0]['segs'].length-1);

		//console.log(`new seglength: ${layers[0]['segs'].length}`)

		count['hold']['now'] = 0;
		count['mode'] = "rev";
		
	}

	const unsubscribe = indSel.subscribe(obj => {
		if (obj.i == -1) return;

		// console.log('** CLICK ** Wall.svelte <-- Starfield.svelte (indSel)')
		// console.log(`ind_Now: ${obj.i}`);


		clickInit(obj.i)
	});

	const unsubscribe_entries = formEntries.subscribe(value => {

		if (Object.keys(value).length == 0) return;

		scroll['submitted'] = true;

		count['paused'] = false;

		if (__myapp.env.isProd) {

			allStars.unshift({
				Authorid: value.Authorid, 
				Colour: value.Colour
			});

			responses[value.Authorid] = value;
		}
		else {

			allStars.unshift({
				Authorid: "new", 
				Colour: `${cols.length-1}`
			});

			responses["new"] = {
				Authorid: "new", 
				Author: "anonymous", 
				Reason:`new entry, id -> "new"`,
				Location: "hello world",
				Published: "1",
				Colour:`${cols.length-1}`
			};
		}
		
		starData.set(allStars);

		clickInit(0);

		animateScroll.scrollToTop({duration:scroll['duration']});

		setPrompts();
	});

	const unsubscribe_scrollTrigger = scrollTrigger.subscribe(value => {
		if (value == false) return;

		if (!scroll['submitted']) {
			animateScroll.scrollTo({element: '#end',duration:scroll['duration']});
		}
	});
	
</script>

<svelte:window on:resize={doResize} />

<h1 class="sr-only">I am getting vaccinated because ...</h1>

<section>
	<main style="background: url('./images/wall.jpg'); background-repeat: repeat; ">
		
		<section>
			<div class="pdtop"></div>

			<div bind:this={main_holder} id="top">
				<canvas bind:this={canvas['main']} aria-live="polite" aria-label={layers[0]?.id > 0 ? `${responses[layers[0]['id']]['Reason']}, ${responses[layers[0]['id']]['Author']}, ${responses[layers[0]['id']]['Location']}` : `Awaiting a response ...`} role="img"></canvas>
			</div>

		</section>
		<section>
			<canvas bind:this={canvas['because']} aria-label="Click a star to explore stories" role="img"></canvas>

			<Starfield cols={cols} drawOutlines={drawOutlines}/>
		</section>

	</main>


	<div class="pd100"></div>

	<div id="end" class="pd">
		<canvas bind:this={canvas['alsobecause']} aria-label="I am getting vaccinated because ..." role="img"></canvas>
	</div>

</section>

<style>

	.sr-only {
		position:absolute;
		left:-10000px;
		top:auto;
		width:1px;
		height:1px;
		overflow:hidden;
	}

	
	.pd100 {
		padding: 100px 0 0 0;
	}

	.pd {
		padding: 50px 0 0 0;
	}

	.pdtop {
		padding-top:20px;
	}

    #top {
    	width:100vw;
    	height: calc(100vh - 20px); /* must match .pdtop in App.js */
    }

</style>